import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
//import { StorageResponse } from "../models/storage/StorageResponse";
//import { FileUploadUrlRequest } from "../models/storage/fileUploadUrlRequest";
//import { FileSasResponse } from "../models/storage/fileSasResponse";
import { UserNotification } from "../models/signalR/userNotification";
import { Helpers } from "../helpers/helpers";
import { IeSafeLead, IFeedback, IFileSasResponse, ITableStatus } from "src/app/models";

@Injectable({
  providedIn: "root",
})
export class StorageService {
  private STORAGE_SERVICE_URL = environment.storageService.url + environment.storageService.apiVersion;
  private USERSESSION_SERVICE_URL = environment.userSessionService.url + environment.userSessionService.apiVersion;

  public constructor(private http: HttpClient) {
  }

  getFileSaSUri(fileId: string) {
    return new Promise<IFileSasResponse>((resolve, reject) => {
      this.http
        .get<IFileSasResponse>(
          this.STORAGE_SERVICE_URL + "storage/File/" + fileId
        )
        .toPromise()
        .then(
          (response?: IFileSasResponse) => {
            resolve(response!);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  expireFile(fileId: string) {
    return new Promise<any>((resolve, reject) => {
      this.http
        .delete<any>(this.STORAGE_SERVICE_URL + "storage/File/" + fileId)
        .toPromise()
        .then(
          (response) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          });
    });
  };

  getUserNotifications(userId: string) {
    return new Promise<UserNotification[]>((resolve, reject) => {
      this.http
        .get<UserNotification[]>(this.USERSESSION_SERVICE_URL + 'user/' + userId + '/' + Helpers.getPlatformId() + '/UserNotification/15')
        .toPromise()
        .then((response) => {
          if (response == null)
            response = [];
          resolve(response);
        },
          (err) => {
            reject(err);
          }
        );
    });
  };

  insertUserNotifications(userNotification: UserNotification) {
    return new Promise<boolean>((resolve, reject) => {
      this.http
        .put<boolean>(this.USERSESSION_SERVICE_URL + 'user/UserNotification', userNotification)
        .toPromise()
        .then((response) => {
          if (response == null)
            response = false;
          resolve(response);
        },
          (err) => {
            reject(err);
          }
        );
    });
  };

  InsertEsafeLead(esafeLead: IeSafeLead) {
    return new Promise<ITableStatus>((resolve, reject) => {
      this.http
        .post<ITableStatus>(this.STORAGE_SERVICE_URL + 'Storage/InsertEsafeLead', esafeLead)
        .toPromise()
        .then((response?: ITableStatus) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          }
        );
    });
  };

  formatBytesToMB(bytes: number, decimals = 2) {
    if (bytes === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const megaBytes = k * k; // One MB is 1024 KB
    const dm = decimals < 0 ? 0 : decimals;
    return parseFloat((bytes / megaBytes).toFixed(dm));
  };

  validateFile(name: string) {
    const ext = name.substring(name.lastIndexOf(".") + 1);
    if (
      ext.toLowerCase() === "txt" ||
      ext.toLowerCase() === "bmp" ||
      ext.toLowerCase() === "tiff" ||
      ext.toLowerCase() === "dicom" ||
      ext.toLocaleLowerCase() === "jpeg" ||
      ext.toLocaleLowerCase() === "gif" ||
      ext.toLocaleLowerCase() === "ppt" ||
      ext.toLocaleLowerCase() === "pptx" ||
      ext.toLowerCase() === "docx" ||
      ext.toLowerCase() === "doc" ||
      ext.toLowerCase() === "xlsx" ||
      ext.toLowerCase() === "xls" ||
      ext.toLowerCase() === "msg" ||
      ext.toLowerCase() === "eml" ||
      ext.toLowerCase() === "csv" ||
      ext.toLocaleLowerCase() === "jpg" ||
      ext.toLowerCase() === "pdf" ||
      ext.toLowerCase() === "rtf"
    ) {
      return true;
    } else {
      return false;
    }
  };

  async uploadFileToAzureBlob(file: File, uploadUri: string): Promise<any> {
    const headers = new HttpHeaders({
      "x-ms-blob-content-type": file.type,
      "x-ms-blob-type": "BlockBlob",
    });

    return new Promise<any>(async (resolve, reject) => {
      await this.http
        .put(uploadUri, file, {
          headers,
        })
        .toPromise()
        .then(
          (response) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  UserInterestedApps(postData: any): Promise<any> {
    return new Promise<any>(async (resolve, reject) => {
      this.http.post<any>(this.STORAGE_SERVICE_URL + `Storage/UserActivity`, postData).toPromise().then((result) => { resolve(result); }, (error) => { reject(error); });
    });
  }

  InsertFeedback(feedback: IFeedback): Promise<ITableStatus> {
    return new Promise<ITableStatus>((resolve, reject) => {
      this.http
        .post<ITableStatus>(this.STORAGE_SERVICE_URL + 'Storage/InsertFeedback', feedback)
        .toPromise()
        .then((response?: ITableStatus) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          }
        );
    });
  }

  //getFileUploadUri(fileName: string, StorageMediumId: string) {
  //  return new Promise<StorageResponse>((resolve, reject) => {
  //    this.http
  //      .post<StorageResponse>(
  //        this.STORAGE_SERVICE_URL + "storage/File/UploadUri",
  //        {
  //          Name: fileName,
  //          StorageMediumId: StorageMediumId,
  //        }
  //      )
  //      .toPromise()
  //      .then(
  //        (response) => {
  //          resolve(response);
  //        },
  //        (err) => {
  //          reject(err);
  //        }
  //      );
  //  });
  //}

  //getCdnFileUploadUri(
  //  fileUploadUrlRequest: FileUploadUrlRequest
  //): Promise<StorageResponse[]> {
  //  return new Promise<StorageResponse[]>((resolve, reject) => {
  //    this.http
  //      .post<StorageResponse[]>(
  //        this.STORAGE_SERVICE_URL +
  //          this.STORAGE_SERVICE_CDNSTORAGE_ROUTE +
  //          "/GetFileUploadUri",
  //        fileUploadUrlRequest
  //      )
  //      .toPromise()
  //      .then(
  //        (response) => {
  //          resolve(response);
  //        },
  //        (err) => {
  //          reject(err);
  //        }
  //      );
  //  });
  //}

  //getFileSaSUri(fileId: string) {
  //  return new Promise<FileSasResponse>((resolve, reject) => {
  //    this.http
  //      .get<FileSasResponse>(
  //        this.STORAGE_SERVICE_URL + "storage/File/" + fileId
  //      )
  //      .toPromise()
  //      .then(
  //        (response) => {
  //          resolve(response);
  //        },
  //        (err) => {
  //          reject(err);
  //        }
  //      );
  //  });
  //}

  //addFileToDb(fileName: string, storageMediumId: string) {
  //  return new Promise<StorageResponse>((resolve, reject) => {
  //    return this.http
  //      .post<StorageResponse>(
  //        this.STORAGE_SERVICE_URL + "storage/AddFileToDB",
  //        {
  //          Name: fileName,
  //          StorageMediumGuid: storageMediumId,
  //        }
  //      )
  //      .toPromise()
  //      .then(
  //        (response) => {
  //          resolve(response);
  //        },
  //        (err) => {
  //          reject(err);
  //        }
  //      );
  //  });
  //}
  //createStorageContainer(
  //  storageContainerName: string,
  //  storageAccountId: string
  //) {
  //  return new Promise<StorageResponse>(async (resolve, reject) => {
  //    try {
  //      const response = await this.http
  //        .post<StorageResponse>(
  //          this.STORAGE_SERVICE_URL + "storage/Containers",
  //          {
  //            StorageAccountId: storageAccountId,
  //            Name: storageContainerName,
  //          }
  //        )
  //        .toPromise();
  //      resolve(response);
  //    } catch (err) {
  //      reject(err);
  //    }
  //  });
  //}

}
